export const ROLES = ['owner', 'admin', 'member', 'guest'] as const;
export type Role = (typeof ROLES)[number];

export const ACCESS_LEVELS = ['view', 'comment', 'edit', 'full'] as const;
export type AccessLevel = (typeof ACCESS_LEVELS)[number];

export const LOCATION_TYPES = ['space', 'folder', 'list'] as const;
export type LocationType = (typeof LOCATION_TYPES)[number];

export const STATUS_TYPES = ['open', 'active', 'done', 'closed'] as const;
export type StatusType = (typeof STATUS_TYPES)[number];

/** 0 = none, 1 = urgent, 2 = high, 3 = normal, 4 = low (ClickUp numbering). */
export const PRIORITIES = [
  { value: 0, label: 'None', color: '#9aa0ad' },
  { value: 1, label: 'Urgent', color: '#e5484d' },
  { value: 2, label: 'High', color: '#f5a524' },
  { value: 3, label: 'Normal', color: '#3b82f6' },
  { value: 4, label: 'Low', color: '#8b8fa3' },
] as const;

export const VIEW_TYPES = ['list', 'board', 'calendar', 'timeline', 'table', 'workload'] as const;
export type ViewType = (typeof VIEW_TYPES)[number];

export const CUSTOM_FIELD_TYPES = [
  'text',
  'long_text',
  'number',
  'currency',
  'date',
  'dropdown',
  'labels',
  'checkbox',
  'url',
  'email',
  'phone',
  'rating',
  'progress',
  'user',
  'relationship',
  'formula',
] as const;
export type CustomFieldType = (typeof CUSTOM_FIELD_TYPES)[number];

/** Palette offered by the color picker and used for seeded data. */
export const COLORS = [
  '#5B3FD6',
  '#7c5cff',
  '#3b82f6',
  '#0ea5e9',
  '#14b8a6',
  '#22c55e',
  '#84cc16',
  '#eab308',
  '#f59e0b',
  '#f97316',
  '#ef4444',
  '#ec4899',
  '#d946ef',
  '#8b5cf6',
  '#64748b',
  '#78716c',
] as const;

export const DEFAULT_STATUSES: { name: string; color: string; type: StatusType }[] = [
  { name: 'To Do', color: '#9aa0ad', type: 'open' },
  { name: 'In Progress', color: '#3b82f6', type: 'active' },
  { name: 'In Review', color: '#f59e0b', type: 'active' },
  { name: 'Done', color: '#22c55e', type: 'done' },
];

export const INVITE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const MAX_UPLOAD_BYTES_DEFAULT = 1024 * 1024 * 1024;
